let currentEvaluationId: string | null = null;

function generateRandomId(): string {
  return Math.random().toString(36).substring(2, 10);
}

export function generateEvaluationId(): string {
  currentEvaluationId = `eval_${Date.now()}_${generateRandomId()}`;
  return currentEvaluationId;
}

export function getCurrentEvaluationId(): string | null {
  return currentEvaluationId;
}
